<template>
  <div>

    <van-nav-bar title="重置密码" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>


    <div style="padding-top: 46px;">


      <div style="padding-left: 24px;padding-right: 24px;padding-top: 80px">
        <van-form validate-first @failed="onFailed" :show-error="false">
          <!-- 通过 pattern 进行正则校验 -->
          <van-field
              v-model="phone"
              name="phone"
              placeholder="请输入手机号"
              :rules="[{ pattern, message: '请输入正确的手机号' }]"
              clearable


          />

          <van-field
              v-model="code"
              placeholder="请输入图形验证码"
              :rules="[{ pattern:patternCode, message: '请输入正确的图形验证码' }]"
              clearable
          >
            <template #button>
              <div @click="getCode">
                <img :src="codeImg" style="height: 33px;width: 95px">
              </div>
            </template>
          </van-field>

          <van-field
              v-model="sms"
              name="sms"
              center
              placeholder="请输入短信验证码"
              :rules="[{ pattern:patternSMS, message: '请输入正确的验证码' }]"
              clearable
          >
            <template #button>
              <div class="getSMS" @click="getSMS">获取验证码</div>
            </template>
          </van-field>


          <van-field
              v-model="newPassword"
              :type="showNPassword?'textarea ':'password'"
              placeholder="请设置新密码(6-20位数字+字母组成)"
              :rules="[{ pattern:patternNPW, message: '请输入6-20位数字+字母组成的新密码' }]"
              clearable
          >
            <template #button>
              <div class="showPassword" @click="showNPassword=!showNPassword">
                <svg-icon :icon-class="showNPassword?'openEyes':'closeEyes'"
                          :style="showNPassword?'height:12px;width:19px':'height:16px;width:19px'"></svg-icon>
              </div>
            </template>
          </van-field>


          <van-field
              v-model="confirmPassword"
              :type="showCPassword?'textarea ':'password'"
              placeholder="请确认新密码"
              :rules="[{ pattern:patternCPW, message: '请输入6-20位数字+字母组成且与新密码一直的确认密码' }]"
              clearable
          >
            <template #button>
              <div class="showPassword" @click="showCPassword=!showCPassword">
                <svg-icon :icon-class="showCPassword?'openEyes':'closeEyes'"
                          :style="showCPassword?'height:12px;width:19px':'height:16px;width:19px'"></svg-icon>
              </div>
            </template>
          </van-field>


          <div style="height: 40px"></div>


        </van-form>
      </div>
      <div style="padding-left: 40px;padding-right: 40px">
        <div class="loginButton" @click="reset">重置密码</div>
      </div>

    </div>


  </div>
</template>

<script>
export default {
  name: "forget",
  data() {
    return {
      phone: '',
      code: '',
      sms: '',
      newPassword: '',
      confirmPassword: '',
      pattern: /^[1][345789][0-9]{9}$/,
      patternCode: /^[A-Za-z0-9]{4}$/,
      patternSMS: /^[0-9]{4}$/,
      patternNPW: /^[A-Za-z0-9]{6,20}$/,
      patternCPW: /^[A-Za-z0-9]{6,20}$/,
      showNPassword: false,
      showCPassword: false,
      codeImg: '',
      requestid: '',
    }
  },
  methods: {

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    getCode() {
      this.$post(this.$store.state.apiUrl + '/sms/get_validateimg', {qdata: this.$encrypt(this.$genQuery({}))}).then(res => {

        this.codeImg = res.data.validate_img
        this.requestid = res.data.requestid
      }).catch(err => {
        console.log(err)
      })
    },
    getSMS() {
      let phoneCheck = this.phone.search(this.pattern)
      let codeCheck = this.code.search(this.patternCode)
      if (phoneCheck === 0 && codeCheck === 0) {
        let query = this.$encrypt(this.$genQuery({
          mobile: this.phone,
          type: 4,
          country_source: 0,
          country_code: 86,
          requestid: this.requestid,
          validate_code: this.code
        }))
        this.$post(this.$store.state.apiUrl + '/sms/get_sms', {qdata: query}).then(res => {

          if (res.status === 0) {
            this.$toast(res.msg);
          } else {
            this.$toast(res.msg);
          }

        }).catch(err => {
          console.log(err)
        })


      } else {
        if (phoneCheck !== 0) {
          this.$toast('请输入正确的手机号');
        } else if (codeCheck !== 0) {
          this.$toast('请输入正确的验证码');
        }
      }
    },
    reset() {
      let phoneCheck = this.phone.search(this.pattern)
      let codeCheck = this.code.search(this.patternCode)
      let smsCheck = this.sms.search(this.patternSMS)
      let nPWCheck = this.newPassword.search(this.patternNPW)
      let cPWCheck = this.confirmPassword.search(this.patternCPW)
      if (phoneCheck === 0 && smsCheck === 0 && nPWCheck === 0 && cPWCheck === 0) {//&& codeCheck === 0


        let query = this.$encrypt(this.$genQuery({mobile:this.phone,password:this.newPassword,sms_code:this.sms,country_source:0,country_code:86}))
        this.$post(this.$store.state.apiUrl + '/member/find_pw',{qdata:query}).then(res=>{
          console.log(res)
          if (res.status ===0){
            this.$toast('重置成功');
            this.$router.push('/userCenter')
          }else {
            this.$toast(res.msg);
          }
        }).catch(err=>{
          console.log(err)
        })




      } else {
        if (phoneCheck !== 0) {
          this.$toast('请输入正确的手机号');
        // } else if (codeCheck !== 0) {
        //   this.$toast('请输入正确的图形验证码');
        } else if (smsCheck !== 0) {
          this.$toast('请输入正确的验证码');
        } else if (nPWCheck !== 0) {
          this.$toast('请输入6-20位数字+字母组成的新密码');
        } else if (cPWCheck !== 0) {
          this.$toast('请输入6-20位数字+字母组成且与新密码一直的确认密码');
        }else if(this.newPassword !== this.confirmPassword){
          this.$toast('确认密码与新密码不一致');
        }
      }
    }
  },
  mounted() {
    this.getCode()
  }
}
</script>

<style scoped>

</style>
